import { Container, Flex } from '@chakra-ui/react';
import { Tabs, RadioGroup, DateRange } from 'components';
import { useState } from 'react';
import { DateRangeState, DATE_OPTIONS} from 'utils';

type DateRangeFilterProps = {
    onChange: ({ startDate, endDate }: DateRangeState) => void;
}

const DateRangeFilter = ({onChange}: DateRangeFilterProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [dateOptions, setDateOptions] = useState<React.ChangeEvent<HTMLInputElement> | string | number>();

    const tabList = [{
      id: 1,
      title: 'Choose dates',
      content: <Container>
                <DateRange onChange={onChange} />
                <Container paddingTop="40px">
                  <RadioGroup options={DATE_OPTIONS} onChange={setDateOptions}/>
                </Container>
              </Container>
    },
    {
      id: 2,
      title: 'I\'m flexible',
      content:<Container>
      <DateRange onChange={onChange} />
      <Container paddingTop="40px">
        <RadioGroup options={DATE_OPTIONS} onChange={setDateOptions}/>
      </Container>
    </Container>
    }];

    return (
      <Flex width="750px" direction="row" alignItems="center">
        <Tabs tabList={tabList} />
      </Flex>
    );
}

export {DateRangeFilter};